import React from "react"
import { FaPinterestP } from "@react-icons/all-files/fa/FaPinterestP"
import { FaYoutube } from "@react-icons/all-files/fa/FaYoutube"
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram"
import { FaFacebookF } from "@react-icons/all-files/fa/FaFacebookF"
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter"
import { FaLinkedinIn } from "@react-icons/all-files/fa/FaLinkedinIn"
import styled from "@emotion/styled"

// import { Img } from 'gatsby'
import { Flex } from "theme-ui"

const FollowUs = styled.div`
    font-size: 20px;
    font-weight: bold;
    color: ${(props) => props.theme.colors.primary};
    margin-bottom: 0.5rem;
    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        font-size: 16px;
    }
`

const CircleIcon = styled.span`
    background-color: ${(props) => props.theme.colors.primary};
    border-radius: 60px;
    padding: 0.5rem;
    padding-bottom: 0.1rem;
    margin-right: 0.5rem;

    & a {
        color: #ffffff !important;

        &:hover {
            padding-left: 0;
            transition: none !important;
            border-left: none;
        }
    }
    &:hover {
        background-color: #273b90;
    }
`

const SocialMedias = (props) => {
    const data = props.company
    const socialMedia = data.SocialMedia

    const socialIcons = {
        facebook: <FaFacebookF size={20} />,
        linkedin: <FaLinkedinIn size={20} />,
        instagram: <FaInstagram size={20} />,
        youtube: <FaYoutube size={20} />,
        pinterest: <FaPinterestP size={20} />,
        twitter: <FaTwitter size={20} />,
    }
    const socialLink = socialMedia.map((data, index) => {
        return (
            <CircleIcon key={index}>
                <a href={data.Link}>{socialIcons[data.social_media_name]}</a>
            </CircleIcon>
        )
    })

    // const SocialMediaIcons = socialMedia.map((social) => (
    //     <a href={social.Link} className="icon-link">
    //         {!social.icon && social.social_media_name === "twitter" ? (
    //             <IconContext.Provider
    //                 value={{ className: componentStyle.iconsExtraSmall }}
    //             >
    //                 <FiTwitter />
    //             </IconContext.Provider>
    //         ) : !social.icon && social.social_media_name === "instagram" ? (
    //             <IconContext.Provider
    //                 value={{ className: componentStyle.iconsExtraSmall }}
    //             >
    //                 <FiInstagram />
    //             </IconContext.Provider>
    //         ) : !social.icon && social.social_media_name === "facebook" ? (
    //             <IconContext.Provider
    //                 value={{ className: componentStyle.iconsExtraSmall }}
    //             >
    //                 <FiFacebook />
    //             </IconContext.Provider>
    //         ) : !social.icon && social.social_media_name === "linkedin" ? (
    //             <IconContext.Provider
    //                 value={{ className: componentStyle.iconsExtraSmall }}
    //             >
    //                 <FiLinkedin />
    //             </IconContext.Provider>
    //         ) : !social.icon && social.social_media_name === "pinterest" ? (
    //             <IconContext.Provider
    //                 value={{
    //                     className:
    //                         componentStyle.iconsExtraSmall +
    //                         " " +
    //                         componentStyle.faIcons,
    //                 }}
    //             >
    //                 <FaPinterestPP />
    //             </IconContext.Provider>
    //         ) : !social.icon && social.social_media_name === "youtube" ? (
    //             <IconContext.Provider
    //                 value={{
    //                     className:
    //                         componentStyle.iconsExtraSmall +
    //                         " " +
    //                         componentStyle.faIcons,
    //                 }}
    //             >
    //                 <FaYoutube />
    //             </IconContext.Provider>
    //         ) : social.icon ? (
    //             <img src={social.icon.publicURL} width="20" height="20" />
    //         ) : null}
    //     </a>
    // ))

    return (
        <>
            <FollowUs>Follow Us On</FollowUs>

            <Flex sx={{ color: "main", justifyContent: "start" }}>
                {socialLink}
                {/* <CircleIcon>
                <FaFacebookF size={20} />
            </CircleIcon>
            <CircleIcon>
                <FaLinkedinIn size={20} />
            </CircleIcon>
            <CircleIcon>
                <FaInstagram size={20} />
            </CircleIcon>
            <CircleIcon>
                <FaYoutube size={20} />
            </CircleIcon>
            <CircleIcon>
                <FaPinterestP size={20} />
            </CircleIcon> */}
            </Flex>
        </>
    )
}

export default SocialMedias
